import React from 'react';
import {Switch, Route, Redirect} from 'wouter';

import {useUserEditingPermissions} from '../../hooks/user/use-has-permission';

import {EditRoute} from './edit-view';
import {ExploreRoute} from './explore-view';
import {useGlobalVersion} from '../../providers/version/use-global-version';

interface Props {
    globalVersionProps: ReturnType<typeof useGlobalVersion>;
}

export const DocumentsRoute = ({globalVersionProps}: Props) => {
    const {editingPermitted} = useUserEditingPermissions();

    return (
        <Switch>
            <Route path="/explore" nest={true}>
                <ExploreRoute globalVersionProps={globalVersionProps} />
            </Route>

            {editingPermitted && (
                <Route path="/edit" nest={true}>
                    <EditRoute globalVersions={globalVersionProps.globalVersions} />
                </Route>
            )}

            <Redirect to="/explore" />
        </Switch>
    );
};
